import { apiClient } from './apiClient';

// ============================================
// TIPOS
// ============================================

export interface DashboardStats {
  users: number;
  posts: number;
  products?: number;
  partners?: number;
}

export interface UsersByRole {
  admin: number;
  creator: number;
  user: number;
  god: number;
}

export interface UsersByStatus {
  active: number;
  inactive: number;
  suspended: number;
}

export interface DashboardOverview {
  stats: DashboardStats;
  usersByRole: UsersByRole;
  usersByStatus: UsersByStatus;
  recentUsers: number;
  recentPosts: number;
  recentProducts?: number;
}

// ============================================
// SERVIÇO
// ============================================

class DashboardService {
  /**
   * Busca estatísticas gerais do dashboard
   */
  async getStats(): Promise<DashboardStats> {
    try {
      // Fazer requisições em paralelo para auth e content
      // marketplace desabilitado por enquanto
      const [usersRes, postsRes] = await Promise.all([
        apiClient.get('/auth/stats/users/count'),
        apiClient.get('/content/stats/posts/count'),
        // apiClient.get('/stats/products/count'),
        // apiClient.get('/stats/partners/count'),
      ]);

      return {
        users: usersRes.data.count || 0,
        posts: postsRes.data.count || 0,
        // products: productsRes.data.count || 0,
        // partners: partnersRes.data.count || 0,
      };
    } catch (error) {
      console.error('Erro ao buscar estatísticas:', error);
      
      // Retorna zeros em caso de erro (fallback)
      return {
        users: 0,
        posts: 0,
        // products: 0,
        // partners: 0,
      };
    }
  }

  /**
   * Busca overview completo (stats + detalhes)
   */
  async getOverview(): Promise<DashboardOverview> {
    try {
      // Fazer requisições em paralelo
      // marketplace desabilitado por enquanto
      const [authOverview, contentOverview] = await Promise.all([
        apiClient.get('/auth/stats/overview'),
        apiClient.get('/content/stats/overview'),
        // apiClient.get('/stats/overview'),
      ]);

      const authData = authOverview.data;
      const contentData = contentOverview.data;
      // const marketplaceData = marketplaceOverview.data;

      return {
        stats: {
          users: authData.totalUsers || 0,
          posts: contentData.totalPosts || 0,
          // products: marketplaceData.totalProducts || 0,
          // partners: marketplaceData.totalPartners || 0,
        },
        usersByRole: authData.usersByRole || { admin: 0, creator: 0, user: 0, god: 0 },
        usersByStatus: authData.usersByStatus || { active: 0, inactive: 0, suspended: 0 },
        recentUsers: authData.recentUsers || 0,
        recentPosts: contentData.recentPosts || 0,
        // recentProducts: marketplaceData.recentProducts || 0,
      };
    } catch (error) {
      console.error('Erro ao buscar overview:', error);
      
      // Retorna dados vazios em caso de erro
      return {
        stats: { users: 0, posts: 0 /*, products: 0, partners: 0 */ },
        usersByRole: { admin: 0, creator: 0, user: 0, god: 0 },
        usersByStatus: { active: 0, inactive: 0, suspended: 0 },
        recentUsers: 0,
        recentPosts: 0,
        // recentProducts: 0,
      };
    }
  }

  /**
   * Busca usuários por role
   */
  async getUsersByRole(): Promise<UsersByRole> {
    try {
      const response = await apiClient.get('/auth/stats/users/by-role');
      return response.data.byRole || { admin: 0, creator: 0, user: 0, god: 0 };
    } catch (error) {
      console.error('Erro ao buscar usuários por role:', error);
      return { admin: 0, creator: 0, user: 0, god: 0 };
    }
  }
}

export const dashboardService = new DashboardService();